<footer class="footer-area">
  <div class="footer-grid gap-32">
    <div>
      <div class="footer-heading mb-12">Get Peech</div>
      <nav class="d-flex flex-column gap-8">
        <a
          class="footer-link"
          href="https://apps.apple.com/app/apple-store/id1429704005?pt=119230880&ct=web-funnel-footer&mt=8"
          >iOS App</a
        >
        <a class="footer-link" href="https://play.google.com/store/apps/details?id=com.peech.android"
          >Android App</a
        >
        <a class="footer-link" href="https://www.getpeech.com/chrome-extension">Chrome Extension</a>
      </nav>
    </div>
    <div>
      <div class="footer-heading mb-12">Support</div>
      <nav class="d-flex flex-column gap-8">
        <a class="footer-link" href="mailto:support@getpeech.com">support&#64;getpeech.com</a>
      </nav>
    </div>
    <div>
      <div class="footer-heading mb-12">Legal</div>
      <nav class="d-flex flex-column gap-8">
        <a class="footer-link" href="https://www.getpeech.com/privacy">Privacy Policy</a>
        <a class="footer-link" href="https://www.getpeech.com/terms">Terms of Service</a>
      </nav>
    </div>
  </div>

  <div class="mt-32 d-flex justify-content-end">
    <div class="fs-14 legal-line">© 2026 Dopefin Limited</div>
  </div>
</footer>
